/**
 * Entry point for the configurator bundle.
 *
 * Per SPEC_DEFECTS F-13 the bootstrap carries no prices: geometry, materials,
 * colours, rules and limits only. Every price comes from POST /sd/v1/price.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import type { Bootstrap } from './types';
import './styles.css';

const ROOT_ID = 'sd-configurator-root';

declare global {
	interface Window {
		SD_BOOTSTRAP?: Bootstrap;
	}
}

export function start(): void {
	const root = document.getElementById(ROOT_ID);

	if (root === null) {
		return;
	}

	const bootstrap = window.SD_BOOTSTRAP;

	if (bootstrap === undefined) {
		// Spec 11.6: no silent failures.
		console.error('[sd-configurator] SD_BOOTSTRAP missing; configurator not mounted.');
		return;
	}

	createRoot(root).render(
		<StrictMode>
			<App boot={bootstrap} />
		</StrictMode>
	);
}

if (typeof document !== 'undefined') {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', start);
	} else {
		start();
	}
}
